/* CaptureAction.js */

"use strict";
const CaptureNameComponent = require("./veils/name/CaptureNameComponent");

class CaptureAction {
    constructor(
        logger,
        gameEditor,
        activeView,
        DeviceEntity,
        userFeedback,
        userSession,
        jnibAdapter
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._activeView = activeView;
        this._modalUserFeedback = userFeedback;
        this._DeviceEntity = DeviceEntity;
        this._userSession = userSession;
        this._selectedDeviceIds = [];

        this._jnibAdapter = jnibAdapter;
        this._nibApiService = this._jnibAdapter.getNibApiService();

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedDeviceIds = this._activeView.getSelectedDeviceIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        // Solution needs to be loaded first, else we ignore this action and let the user know
        return this._nibApiService
            .doesRefExist({
                orgId: this._userSession.activeOrganization.id,
                ref: "sys/jnib/features/deviceDetect/discoverDeviceJob.jnib",
            })
            .then((exists) => {
                if (exists) {
                    return this._modalUserFeedback
                        .displayCustom(
                            new CaptureNameComponent(
                                this._logger,
                                this._userSession,
                                this._activeView,
                                this._selectedDeviceIds,
                                this._DeviceEntity,
                                this._modalUserFeedback
                            ),
                            {dontHide: true}
                        )
                        .then(() => this._modalUserFeedback.hideDisplayed())
                        .catch((err) => {
                            if (err && err.userRejected) {
                                return this._modalUserFeedback.hideDisplayed();
                            } else {
                                this._logger.warn({error: err}, "CaptureAction.run() - Error");
                                return this._modalUserFeedback.displayError(err).catch(() => {
                                    return Promise.resolve();
                                });
                            }
                        });
                } else {
                    this._modalUserFeedback.displayError({
                        errorMsg:
                            "Looks like you don’t have the Device Discovery package installed. Go to Solutions Management to install it.",
                        errorCode: "",
                    });
                    return false;
                }
            })
            .catch((err) => {
                this._logger.warn({error: err}, "CaptureAction.run().getNibApiService - Error");
                return this._modalUserFeedback.displayError(err);
            });
    }
}

module.exports = CaptureAction;

CaptureAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.entities.Device",
    "$teve.ui.userFeedback",
    "$teve.userSession",
    "$teve.jnibAdapter",
];

CaptureAction.$displayDetails = {
    type: "Action",
    name: "CaptureAction",
    icon: "configdrift.snapshot",
    shown: true,
    title: "Capture Snapshot",
    order: 7,
};
